import clsx from 'clsx'
import { Button } from 'components/Button/Button'
import ServiceReportEmbed from 'components/ServiceReportEmbed/ServiceReportEmbed'
import { useUser } from 'hooks/user'
import { ReactComponent as GearSvg } from 'images/icons/gear.svg'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { buildServiceReportParameters, canSeeServiceReport } from 'utils/serviceReportForm'
import type { VendorCode } from 'utils/vendorDisplayName'

import style from './Service.module.css'

type ServiceReportRowProps = {
  serialNumber?: string | null
  robotType?: string | null
  robotTypeDisplay?: string | null
  vendor?: VendorCode | string | null
}

const ServiceReportRow = ({ serialNumber, robotType, robotTypeDisplay, vendor }: ServiceReportRowProps) => {
  const { t } = useTranslation()
  const user = useUser()
  const [isOpen, setIsOpen] = useState(false)

  const parameters = useMemo(
    () =>
      buildServiceReportParameters({
        serialNumber,
        robotType,
        robotTypeDisplay,
        vendor,
        firstName: user?.state.firstName,
        lastName: user?.state.lastName,
      }),
    [serialNumber, robotType, robotTypeDisplay, vendor, user?.state.firstName, user?.state.lastName]
  )

  if (!canSeeServiceReport({ audience: user?.state.audience ?? null, vendor })) {
    return null
  }

  return (
    <>
      <div className={style.tableHeaderRow}>
        <div className={style.centered}>{t('robot.service_report_title')}</div>
      </div>
      <div className={style.tableRow}>
        <div className={style.centered}>
          <GearSvg className={style.rowTaskIcon} />
        </div>
        <div className={clsx(style.chip, style.centered, style.locked)}>
          <Button.Standart className={style.button} onClick={() => setIsOpen(true)}>
            {t('robot.service_report_button')}
          </Button.Standart>
        </div>
        <div className={clsx(style.chipSmallFont, style.centered, style.locked)} />
      </div>
      <ServiceReportEmbed isOpen={isOpen} onClose={() => setIsOpen(false)} parameters={parameters} />
    </>
  )
}

export default ServiceReportRow
